import "./icon.custom.aiRecent.css"
import type { ComponentProps } from "react"

// A list glyph with the AI spark tucked into its bottom-right corner, inside
// the icon's own box so it never shifts the layout. Lines follow
// currentColor; the spark is painted with the primary token via CSS.
export default function AiRecent(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...svgProps}
    >
      <path d="M3 6h.01M8 6h13M3 12h.01M8 12h13M3 18h.01M8 18h4" />
      <path
        className="ai-recent__spark"
        stroke="none"
        d="M18.5 13l1.1 3.4 3.4 1.1-3.4 1.1-1.1 3.4-1.1-3.4-3.4-1.1 3.4-1.1z"
      />
    </svg>
  )
}
